const _ = require('./_');
const stringUtil = require('./string-util');

function translateUserSearchToRegex(userSearchString) {
  if (!userSearchString || /^\s+$/.test(userSearchString)) {
    return new RegExp('\\.*'); // match anything
  }

  let search = userSearchString;
  search = search.replace(/\\/g, '\\\\');
  search = search.replace(/\+/g, '\\+');
  search = search.replace(/\s+/g, '\\s+');
  search = search.replace(/\./g, '\\.');
  search = search.replace(/\*/g, '.*');
  return new RegExp(search, 'i');
}

function isMatchString(target, test, options) {
  const regex = translateUserSearchToRegex(test);

  let sanitizedTarget = target;
  if (options && options.stripHTMLTags) {
    sanitizedTarget = stringUtil.stripHTMLTags(target);
  }

  return regex.test(sanitizedTarget);
}

function isMatchObject(target, test, options) {
  return Object.keys(target).some(key => isMatch(target[key], test, options)); // eslint-disable-line no-use-before-define
}

function isMatchArray(target, test, options) {
  return target.some(o => isMatch(o, test, options)); // eslint-disable-line no-use-before-define
}

function isMatch(target, test, options) {
  if (!test) {
    return false;
  }

  if (_.isString(target)) {
    return isMatchString(target, test, options);
  }
  if (Array.isArray(target)) {
    return isMatchArray(target, test, options);
  }
  if (_.isObject(target)) {
    return isMatchObject(target, test, options);
  }

  return false;
}

module.exports = {
  isMatch,
  translateUserSearchToRegex,
};
